export enum OrderSourceType {
    Web = 34,
    Telephone = 35,
    POS = 36
}

export enum ShippingOrderType {
    Personal = 17,
    AutoShip = 18,
    DropShip = 19
}

export enum PriceType {
    RETAILPRICE = 14,
    WHOLESALEPRICE = 15,
    SELLINGPRICE = 16,
}

export enum ShippingType {
    DELIVERY = 1,
    PICKUP = 2 ,
    DROPSHIP = 42
}

export enum ProductWeightMetric {
    KGS = 10,
    OUNCES = 11,
    LBS = 12,
    GRAMS = 13
}

export enum PaymentMethodTypes {
    Credit_Card = 'Credit_Card',
    eCheck = 'eCheck',
    Money_order = 'Money_Order',
    Bank_Transfer = 'Bank_Transfer',
    Cash_On_Delivery = 'Cash_On_Delivery',
    Cash = 'Cash',
    Ideal = 'Ideal',
    PayPal = 'PayPal',
    Pos = 'Pos',
    Prdpay = 'Prdpay',
    Ach ='Ach',
    Credit_Card_External='Credit_Card_External',
    Bonus_Check='Bonus_Check',
    Personal_Check='Personal_Check',
    Travelers_Check='Travelers_Check',
    BanContact_MisterCash_and_Maestro='BanContact_MisterCash_and_Maestro',
    MisterCash_and_Maestro='MisterCash_and_Maestro',
    Service_Order = 'Service_Order',
    Trustly = 'Trustly',
    Vipps = 'Vipps',
    MobilePay = 'MobilePay',
    Swish = 'Swish',
    Single_Debit = 'Single_Debit',
    Direct_Debit = 'Direct_Debit',
    Pay_By_Link = 'Pay_By_Link',
    Saved_Cards = 'Saved Cards',
    Wire_Transfer = 'Wire_Transfer',
    Eps = 'EPS',
    Giro_Pay = 'GiroPay',
    Blik = 'BLIK',
    Orange_Money = 'Orange_Money',
    Wave = 'Wave',
    Integrated_Terminal_Adyen = 'Integrated_Terminal_Adyen',
    Money_Order = 'Money_Order',
    Google_Pay = 'Google_Pay',
    Apple_Pay = 'Apple_Pay',
    Walley = 'walley',
    Twint = 'TWINT',
    ApplePay_Adyen = 'ApplePay_Adyen',
    Dori_Pay = 'DoriPay',
    Riverty = 'Riverty',
    GooglePay_Adyen = 'GooglePay_Adyen'
}

export enum OrderStatus {

    Pending = 1,
    Cancelled = 2,
    Accepted = 3,
    Shipped = 4,
    Ready_For_Pickup = 5,
    Awaiting_Funds = 6,
    Declined = 7,
    Deleted = 8,
    Completed = 9,
    Failed = 10,
    Review_Window = 11,
    Processing = 12,
    In_Complete = 15
}

export enum PaymentType {
    Credit_Card = 1,
    eCheck = 2,
    Money_order = 3,
    Cash=4,
    PayPal = 5,
    Ideal = 6,
    Cash_On_Delivery=7,
    Bank_Transfer = 8,
    BanContact_MisterCash_and_Maestro=21,
    MisterCash_and_Maestro=22,
    Service_Order = 28,
    Single_Debit = 29,
    Direct_Debit = 30,
    Pay_By_Link = 31,
    Saved_Cards = 32,
    Wire_Transfer = 35,
    Orange_Money = 37,
    Nexio_Credit_Card = 14,
    INTEGRATED_TERMINAL = 41,
    Google_Pay = 43,
    Apple_Pay = 42,
    Walley = 45,
    Twint = 44,
    Riverty = 53,
    GooglePay_Adyen = 51,
    ApplePay_Adyen = 50
}

export enum PurchaseFlows {
    RETAIL = 'RETAIL',
    ENROLLMENT = 'ENROLLMENT',
    AUTOSHIP = 'AUTOSHIP',
    PERSONAL = 'PERSONAL',
    FPC5PERCENT = 'FPC-5PERCENT'
}

export enum PurchaseFlowType {
    Retail = 7,
    WholeSale = 8,
    Enrollment = 9
}

export enum AddressType {
    SHIPPING = 40,
    BILLING = 50,
    MAILING = 49,
    PICKUP = 51,
    PUDO = 148,
    PICKUP_PERSON = 147,
    DROPSHIP = 42
}

export enum PromotionsTypes {
    Autoship = 1,
    Join = 2
}

export enum PosPaymentMethodsEnum{
    Credit_Card=1,
    eCheck=2,
    Money_Order=3,
    Cash=4,
    PayPal=5,
    Ideal=6,
    Cash_On_Delivery=7,
    Bank_Transfer=8,
    Pos=9,
    Prdpay=10,
    Global_CreditCard=12,
    Credit_Card_External=14,
    Bonus_Check=15,
    Personal_Check=16,
    Credit_Or_Debit_Card_External_Terminal=17,
    Credit_or_Debit_Card_Internal=18,
    Saved_Cards_Internal=19,
    Travelers_Check=20,
    Direct_Debit= 30,
    Pay_By_Link = 31,
    Wire_Transfer = 35
}

export enum PaymentStatusId{
    REFUND_INITIATED = 11,
    CANCEL_INITIATED = 12,
    PEND = 4,
    PAYMENT_COMPLETED = 6,
    CANCEL_OR_REFUND_INITITATED = 14
}

export enum Source{
    Customer_Service ='Customer Service',
    CSP = 'CSP',
    SERVICE = 'SERVICE',
    POS = 'POS'
}



// WEBPACK FOOTER //
// ./src/app/customerservice/enums/order-source-type.ts